import React from 'react';
import { Container as ChakraContainer } from '@chakra-ui/react';

export default function Container({ children, ...props }) {
  return (
    <ChakraContainer maxW="1280px" px={{ base: 4, md: 6, lg: 8 }} {...props}>
      {children}
    </ChakraContainer>
  );
}
